import type {
	Components,
} from '@mui/material'

export const materialUICheckboxTheme: {
	components: Components
} = {
	components: {
		MuiCheckbox: {
			styleOverrides: {
				root: {
				},
			},
		},
	},
}
